module.exports = __webpack_public_path__ + "static/img/icon-1024.05c54efa.png";